import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { CountersService } from '../lib/counters.service'
import { useCountersResources } from './useCountersResources'

export const COUNTERS_LIST_RQ_KEY = 'counters-list'

type Params = {
  premiseId?: string
  onlyAvailable: boolean
}

export const useCountersList = ({ onlyAvailable, premiseId }: Params) => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  const { status, data, error, isLoading, isFetching, isError } = useQuery({
    queryKey: [COUNTERS_LIST_RQ_KEY, projectId, premiseId, onlyAvailable],
    queryFn: () =>
      CountersService.getCountersList({ projectId, premiseId, onlyAvailable }),
    placeholderData: keepPreviousData,
    select: data => data.data
  })

  const { data: resources } = useCountersResources()

  const countersWithUnits = useMemo(
    () =>
      data?.map(counter => {
        return {
          ...counter,
          unit:
            resources?.find(
              resource => resource.alias === counter.resourceAlias
            )?.unit ?? ''
        }
      }),
    [data, resources]
  )

  return {
    data: countersWithUnits,
    error,
    isError,
    isLoading,
    isFetching,
    status
  }
}
